import { connect } from "react-redux";
import { selectConstants, selectTags } from "../../redux/selectors/firebase";
import Style, { getInitialStyle, StyleOptions } from "../../utility/Style";
import { paletteColors } from "../sheets/conditionalFormatting/DefaultStyles";
import { Constants, Tags } from "./StateTags";

interface Props
{
    constants: Constants
    tags: Tags
}

function ChipStyles({ constants, tags }: Props)
{
    const chipConstant = Object.entries(constants).filter(([id, constant]) => constant.chip !== undefined)
    return <>
        {
            chipConstant.map(([id, constant], index) =>
            {
                const name = `chip_${id.replaceAll(" ", "_")}`;

                if (constant.chip !== "auto")
                {
                    return <Style key={`chip${id}`} name={name} style={constant.chip as StyleOptions} />
                }

                const color = paletteColors[index % paletteColors.length];

                return <Style key={id} name={name} style={{...getInitialStyle(), backColor: color}}/>
            })
        }</>
}

const mapStateToProps = (store: never) => ({
    constants: selectConstants(store) ?? {},
    tags: selectTags(store) ?? {}
});
export default connect(mapStateToProps, {
})(ChipStyles);